import { MouseEvent, useState } from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
  // Badge,
  Button,
  Container,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@mui/material';
import { NavLink } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MenuIcon from '@mui/icons-material/Menu';

// import cartIcon from '../../../assets/icons/cart-icon.svg';
import mailIcon from '../../../assets/icons/mail-icon.svg';
import phoneIcon from '../../../assets/icons/call-icon.svg';
import navLogo from '../../../assets/images/EPIC-WHITE.png';
import UserProfile from '@/components/UserProfile';

type MainNavItem = {
  label: string;
  path?: string;
  externalHref?: string;
  dropdownItems?: Array<{ label: string; path: string }>;
};

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const isMenuOpen = Boolean(anchorEl);

  // const cartItemCount = 10;

  const mainNavItems: MainNavItem[] = [
    { label: 'HOME', path: '/' },
    { label: 'PRODUCTS', path: '/products' },
    { label: 'APPLICATIONS', path: '/application' },
    { label: 'NANOVISION', externalHref: 'https://epicnanovision.com' },
    {
      label: 'OUR STORY',
      path: '/mission-vision',
      dropdownItems: [
        { label: 'MISSION & VISION', path: '/mission_vision' },
        { label: 'TEAM', path: '/team' },
        { label: 'ADVISORS', path: '/advisors' },
      ],
    },
    { label: 'PARTNERSHIPS', path: '/partnership' },
    {
      label: 'EVENTS',
      path: '/events',
    },
  ];

  const mobileNavItems = [
    { label: 'CAREERS', path: '/careers' },
    { label: 'CONTACT US', path: '/contact_us' },
  ];

  const handleMenuOpen = (e: MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const toggleDrawer = (open: boolean) => () => {
    setMobileOpen(open);
  };

  const drawer = (
    <Box
      sx={{ width: 250, backgroundColor: 'primary.main', height: '100%' }}
      role="presentation"
      onClick={toggleDrawer(false)}
    >
      <List sx={{ backgroundColor: 'primary.main' }}>
        {mainNavItems.map((item) =>
          item.dropdownItems ? (
            <Accordion
              key={item.label}
              sx={{
                backgroundColor: 'primary.main',
                color: 'white',
                '&.MuiAccordion-root': {
                  boxShadow: 'none',
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
                onClick={(event) => event.stopPropagation()}
                sx={{
                  color: 'white',
                  '& .MuiTypography-root': {
                    fontFamily: 'Poppins',
                    fontSize: '13px',
                    fontWeight: 500,
                  },
                }}
              >
                <Typography sx={{ fontFamily: 'Poppins' }}>{item.label}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {item.dropdownItems.map((dropdown) => (
                  <ListItem
                    key={dropdown.label}
                    component={NavLink}
                    to={dropdown.path}
                    onClick={toggleDrawer(false)}
                    sx={{
                      paddingLeft: 4,
                      color: 'white',
                      '& .MuiTypography-root': {
                        fontFamily: 'Poppins',
                        fontSize: '13px',
                      },
                    }}
                  >
                    <ListItemText primary={dropdown.label} />
                  </ListItem>
                ))}
              </AccordionDetails>
            </Accordion>
          ) : 'externalHref' in item && item.externalHref ? (
            <ListItem
              key={item.label}
              component="a"
              href={item.externalHref}
              target="_blank"
              rel="noopener noreferrer"
              onClick={toggleDrawer(false)}
              sx={{ color: 'white' }}
            >
              <ListItemText
                primary={item.label}
                sx={{
                  '& .MuiTypography-root': {
                    fontFamily: 'Poppins',
                    fontSize: '13px',
                  },
                }}
              />
            </ListItem>
          ) : (
            <ListItem
              key={item.label}
              component={NavLink}
              to={item.path!}
              onClick={toggleDrawer(false)}
              sx={{ color: 'white' }}
            >
              <ListItemText
                primary={item.label}
                sx={{
                  '& .MuiTypography-root': {
                    fontFamily: 'Poppins',
                    fontSize: '13px',
                  },
                }}
              />
            </ListItem>
          )
        )}
        {mobileNavItems.map((item) => (
          <ListItem
            key={item.label}
            component={NavLink}
            to={item.path}
            onClick={toggleDrawer(false)}
            sx={{
              color: 'white',
              '& .MuiTypography-root': {
                fontFamily: 'Poppins',
                fontSize: '13px',
              },
            }}
          >
            <ListItemText primary={item.label} />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      {/* Top bar for contact info */}

      <Box
        sx={{
          backgroundColor: 'black',
          color: 'white',
        }}
      >
        <Container maxWidth="xl">
          <Box
            sx={{
              py: 0.8,
              display: { xs: 'none', md: 'flex' },
              justifyContent: 'space-between',
              px: 0,
            }}
          >
            <Box sx={{ display: 'flex', gap: 4 }}>
              <Typography
                variant="caption"
                component="a"
                href="mailto:contact@epicbnnt.com"
                target="_blank"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  textDecoration: 'none',
                  color: 'inherit',
                  gap: '6px',
                  fontWeight: '600',
                }}
              >
                <img src={mailIcon} alt="mailIcon" />
                contact@epicbnnt.com
              </Typography>
              <Typography
                variant="caption"
                component="a"
                href="tel:+1-800-581-4528"
                target="_blank"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  textDecoration: 'none',
                  color: 'inherit',
                  gap: '6px',
                  fontWeight: '600',
                }}
              >
                <img src={phoneIcon} alt="mailIcon" />
                +1-800-581-4528
              </Typography>
            </Box>
            <Box>
              <List
                sx={{
                  display: 'flex',
                  whiteSpace: 'nowrap',
                  gap: 2,
                  padding: '0px',
                }}
              >
                {mobileNavItems.map((item) => (
                  <ListItem key={item.label} component={NavLink} to={item.path} sx={{ padding: '0px' }}>
                    <ListItemText
                      primary={item.label}
                      sx={{
                        '& .MuiTypography-root': {
                          fontSize: '13px',
                          color: 'white',
                        },
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          </Box>
        </Container>
      </Box>

      {/* Main AppBar */}
      <AppBar position="sticky">
        <Container
          maxWidth="xl"
          sx={{
            px: { xs: 0, md: '0px' },
          }}
        >
          <Toolbar>
            <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
              <NavLink to="/" style={{ height: 75, padding: '10px 0' }}>
                <img src={navLogo} alt="Logo" style={{ height: 55 }} />
              </NavLink>
            </Box>
            <Box
              sx={{
                display: { xs: 'none', md: 'flex' },
                gap: { xs: 0.5, lg: 1 },
              }}
            >
              {mainNavItems.map((item) =>
                item.dropdownItems ? (
                  <Button
                    key={item.label}
                    color="inherit"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={handleMenuOpen}
                    sx={{
                      fontWeight: 400,
                      fontSize: { xs: '11px', md: '13px', lg: '15px' },
                    }}
                  >
                    {item.label}
                    <ExpandMoreIcon />
                  </Button>
                ) : 'externalHref' in item && item.externalHref ? (
                  <Button
                    key={item.label}
                    color="inherit"
                    component="a"
                    href={item.externalHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      fontWeight: 400,
                      fontSize: { xs: '11px', md: '13px', lg: '15px' },
                    }}
                  >
                    {item.label}
                  </Button>
                ) : (
                  <Button
                    key={item.label}
                    color="inherit"
                    component={NavLink}
                    to={item.path!}
                    sx={{
                      fontWeight: 400,
                      fontSize: { xs: '11px', md: '13px', lg: '15px' },
                    }}
                  >
                    {item.label}
                  </Button>
                )
              )}
            </Box>
            <Box sx={{ display: 'flex', gap: 1 }}>
              {/* <IconButton color="secondary" component={NavLink} to="/cart">
                <Badge
                  badgeContent={cartItemCount > 9 ? '9+' : cartItemCount}
                  // color="secondary"
                  sx={{
                    '& .MuiBadge-badge': {
                      backgroundColor: 'custom.orange',
                      color: 'common.white',
                      fontSize: '10px',
                    },
                  }}
                >
                  <img src={cartIcon} alt="carticon" style={{ height: 20 }} />
                </Badge>
              </IconButton> */}
              <UserProfile />
            </Box>

            {/* hamberger menu */}
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={toggleDrawer(true)}
              sx={{ display: { xs: 'flex', md: 'none' }, marginLeft: '6px' }}
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </Container>
      </AppBar>

      {/* Drawer for mobile navigation */}
      <Drawer anchor="left" open={mobileOpen} onClose={toggleDrawer(false)}>
        {drawer}
      </Drawer>

      {/* Dropdown Menu */}
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleMenuClose}
        slotProps={{
          paper: {
            sx: {
              backgroundColor: 'transparent',
              boxShadow: 'none',
              transition: 'none !important',
            },
          },
        }}
        MenuListProps={{
          sx: {
            backgroundColor: 'custom.grey',
            padding: 0,
            borderRadius: '1px',
          },
        }}
      >
        {mainNavItems
          .find((item) => item.dropdownItems && item.label === anchorEl?.textContent)
          ?.dropdownItems?.map((dropdown) => (
            <MenuItem
              key={dropdown.label}
              component={NavLink}
              to={dropdown.path}
              onClick={handleMenuClose}
              sx={{
                backgroundColor: 'custom.grey',
                color: 'common.white',
                fontSize: { xs: '11px', md: '13px', lg: '15px' },
              }}
            >
              {dropdown.label}
            </MenuItem>
          ))}
      </Menu>
    </>
  );
};

export default Header;
